// import { Code, Rocket, Users, CheckCircle, Circle, Loader2 } from "lucide-react";

const phases = [
  {
    phase: "Phase I",
    title: "Benchmarking Platform",
    subtitle: "Foundations for transparent and automated performance testing of ZK circuits.",
    status: "In Progress",
    icon: "code",
    color: "#667eea",
    features: [
      {done: true, text: "In-browser Circuit Editor"},
      {done: true, text: "Parallel benchmarking engine"},
      {done: false, text: "Automated benchmark reports"},
      {done: false, text: "Open-source runners"}
    ]
  },
  {
    phase: "Phase II",
    title: "Deployment & Integrations",
    subtitle: "Turning benchmarks into production pipelines through seamless deployments and framework integrations.",
    status: "Planned",
    icon: "rocket",
    color: "#764ba2",
    features: [
      {done: false, text: "One-click Deployments (Prover & Verifier)"},
      {done:false,  text: "CRS Generation / Key Ceremonies"},
      {done:false,  text: "Usage Based Billing"},
      {done:false,  text: "Framework Integrations"},
    ]
  },
  {
    phase: "Phase III",
    title: "Enterprise Readiness",
    subtitle: "Expanding for scale, security, and team collaboration in real-world zero-knowledge infrastructure.",
    status: "Planned",
    icon: "users",
    color: "#5e72e4",
    features: [
      {done: false, text: "Team and Enterprise accounts"},
      {done: false, text: "Organization Management & SSO"},
      {done: false, text: "Advanced Analytis"},
      {done:false,  text: "Private Deployments (BYOC & On-Premises)"},
    ]
  }
];

export function Roadmap() {
   return (
    <section className="section has-background-white-bis">
      <div className="container is-max-desktop mx-auto px-4 ">
        <div className="has-text-centered mb-6">
          <h2 className="mb-4">Product Roadmap</h2>
          <p className="is-size-5 has-text-text-60 mx-auto">
            Building the backbone of zero-knowledge operations, step by step
          </p>
        </div>
        <div className="is-centered mx-auto">

          {phases.map( (phase, index) => (
            <>
          <div className="card is-primary has-background-white p-2" style={{ 
                    border: `1px solid ${phase.color}`,
                    marginBottom: index < phases.length - 1 ? '2rem' : '0'
                  }}
                key={`phase-${index}`}>
            
            <div className="card-content">
                <div className="columns is-vcentered">
                    <div className="column is-narrow">
                        <span className="icon is-large p-6" style={{ 
                          borderRadius: "1rem",
                          background:  `linear-gradient(135deg, ${phase.color}15, ${phase.color}25)`,
                          color:  phase.color
                        }}>
                            <i className={`fas fa-2x fa-${phase.icon}`}></i>
                        </span>
                    </div>
                    <div className="column">
                        <div className="mb-4">
                              <p className="is-size-7 has-text-grey has-text-weight-normal mb-0">{phase.phase}</p>
                              <p className="is-size-5">{phase.title}</p>
                        </div>
                        
                        <ul className="">
                        {phase.features.map((feature, featureIndex) => (
                          <li key={`feature-step-${featureIndex}`} className="">
                            <span className="icon-text">
                                <span className="icon">
                                    {feature.done ? (
                                    <i className="fa-regular fa-circle-check" style={{ color: phase.color }} />
                                    ) : (
                                    <i className="fa-regular fa-circle has-text-grey" />
                                    )}
                                </span>
                                <span className="has-text-grey is-size-7-mobile">{feature.text}</span>
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="column is-right is-narrow has-text-right has-text-centered-mobile">
                      <span 
                            className="px-4 py-2 rounded-lg "
                            style={{
                                
                                background: `${phase.color}20`,
                                color:  phase.status === "In Progress" ? phase.color : '#7a7a7a',
                                border: `1px solid ${phase.color}40`,
                                borderRadius: '0.5em'
                            }}
                            >
                            {phase.status === "In Progress" && <span className="icon"><i className="fas fa-circle-notch fa-spin"></i></span>}
                            {phase.status}
                            </span>
                    </div>
                </div>
            </div>
            </div>

            {/* Timeline Connector */}
            {index < phases.length - 1 && (
                <div className="my-4">
                    <div className="is-vcentered mx-auto" style={{ height: '32px', width: '2px', background: 'linear-gradient(to bottom, #d1d5db, transparent)' }} />
                </div>
            )}
            </>
          ))}
        </div>

        {/* Feedback CTA */}
        <div className="has-text-centered mt-4">
          <p className="has-text-grey has-text-weight-semibold">
            Have feedback or suggestions for our roadmap?{" "}
            <a href="#waitlist" className="has-text-link has-text-weight-semibold is-underline">Let us know</a>
          </p>
        </div>
      </div>
    </section>
  );
}
